<div class="p-1">
  <div class="d--f jc--sb bb-1 pb-1">
    <div class="grey-color f-700 fs-22">
      {{ isEditMode ? "Edit Speciality" : "Add New Speciality" }}
    </div>
    <div>
      <mat-icon color="primary" class="pointer f-700" (click)="cancelForm()">close</mat-icon>
    </div>
  </div>
  <form [formGroup]="specialityFormGroup" (ngSubmit)="!isLoading && submit()">
    <div class="mt-2">
      <mat-form-field style="width: 100%" color="primary" appearance="outline">
        <mat-label>Speciality Name *</mat-label>
        <input formControlName="name" matInput type="text" />
        <mat-error *ngIf="specialityFormGroup.get('name').hasError('required')">
          Name is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="d--f jc--fe f--g-1 mt-2">
      <button mat-raised-button color="primary" type="submit" [style.opacity]="isLoading ? 0.5 : 1">
        {{ isEditMode ? "Save" : "Add" }}
        <mat-icon class="ml-2" *ngIf="isLoading">
          <mat-spinner color="accent" diameter="20"> </mat-spinner>
        </mat-icon>
      </button>
    </div>
  </form>
</div>
